import axios from "axios";

export const state = {
    loancharges: [],
};

export const getters = {
    loancharges: (state) => state.loancharges,
};

export const mutations = {
    setLoanCharges(state, newValue) {
        state.loancharges = newValue;
    },
};

export const actions = {
    async fetchLoanCharges({ commit }) {
        await axios.get("/loan-charges").then((res) => {
            commit("setLoanCharges", res.data.loan_charges);
        });
    },
};
